import { apiClient } from '../../axios';
import {
  GetMarketCountryRestrictionResponse,
  GetMarketTradingCalendarResponse,
  GetSymbolsParams,
  GetSymbolsResponse,
  MarketPlatformEnum,
  MarketStats,
} from './types';

export const getSymbolsApi = (params?: GetSymbolsParams) =>
  apiClient.get<GetSymbolsResponse>('/v2/market/symbols', {
    params: { platform: MarketPlatformEnum.Web, ...params },
  });

export const getMarketStatsApi = (currency: string) => apiClient.get<MarketStats>(`/v2/market/stats/${currency}`);

export const getMarketCountryRestrictionApi = (symbol: string) =>
  apiClient.get<GetMarketCountryRestrictionResponse>(`/v2/market/country-restriction/${symbol}`);

export const getMarketTradingCalendarApi = () =>
  apiClient.get<GetMarketTradingCalendarResponse>(`/v2/market/trading-calendar`);
